export default function WhatsAppFloat() {
    const whatsappNumber = '5511993790632';
    const message = 'Olá! Gostaria de saber mais sobre a blindagem de vidros Iron Glass.';

    const handleClick = () => {
        const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    return (
        <button
            onClick={handleClick}
            className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl hover:shadow-green-500/50 transition-all duration-300 transform hover:scale-110 group"
            aria-label="Falar com a gente no WhatsApp"
        >
            <i className="ri-whatsapp-line text-3xl"></i>
            <div className="absolute -top-2 -right-2 bg-red-500 rounded-full w-4 h-4 animate-pulse"></div>
        </button>
    );
}

